import React, { useEffect, useState } from "react";
import { dispatch } from "store";
import StockListCommons from "../StockListCommons";
import {
  adminStockSelector,
  getAdminStockThunk,
} from "store/reducers/inventory/stock/adminStockSlice";
import { useSelector } from "react-redux";
import TransferAdminStock from "./menu/TransferAdminStock";
import ReturnAdminStock from "./menu/ReturnAdminStock";
import { Box, Button, Stack } from "@mui/material";
import AutoCompleteList from "components/AutoCompleteList";
import { getAdminThunk } from "store/reducers/accounts";
import { useNavigate } from "react-router-dom";

const AdminStockList = () => {
  useEffect(() => {
    dispatch(getAdminStockThunk());
  }, []);
  const navigate = useNavigate();
  const roles = useSelector((state) => state.auth.user.roles);
  const items = useSelector(adminStockSelector.selectAll);
  const [returnOpen, setReturnOpen] = useState(false);
  const [transferOpen, setTransferOpen] = useState(false);
  const [stock, setStock] = useState(null);

  const openMainStockReturn = (item) => {
    setReturnOpen(true);
    setStock(item);
  };
  const openTransfer = (item) => {
    setTransferOpen(true);
    setStock(item);
  };
  useEffect(() => {
    dispatch(getAdminThunk());
  }, []);
  const admins = useSelector((state) => state.accounts.admins);
  const [admin, setAdmin] = useState(null);
  useEffect(() => {
    if (admin) {
      dispatch(getAdminStockThunk(admin.profile.id));
    }
  }, [admin]);

  return (
    <Box padding={3}>
      <Stack marginBottom={2} direction="row" justifyContent="space-between">
        {roles.includes("super_admin", "admin") && (
          <Box width={300}>
            <AutoCompleteList
              items={admins}
              name="username"
              label="Filter admin"
              setValue={setAdmin}
              value={admin}
            />
          </Box>
        )}
        <Button
          variant="outlined"
          onClick={() => {
            navigate(
              admin ? `logs?admin=${admin.id}` : "logs"
            );
          }}
        >
          View transaction logs
        </Button>
        <Button
          variant="outlined"
          onClick={() => {
            navigate(
              admin ? `history?admin=${admin.id}` : "history"
            );
          }}
        >
          View stock history
        </Button>
      </Stack>
      <StockListCommons
        items={items}
        openStockReturn={openMainStockReturn}
        openTransfer={openTransfer}
        stock={stock}
        returnOpen={returnOpen}
        transferOpen={transferOpen}
        setReturnOpen={setReturnOpen}
        setTransferOpen={setTransferOpen}
        ReturnStock={ReturnAdminStock}
        TransferStock={TransferAdminStock}
        hasEditPermissions={roles.includes("admin")}
      />
    </Box>
  );
};

export default AdminStockList;
